<script>
import UtilsMixin from "@/mixins/utils";
import VueI18n
  from "vue-i18n";
import {loadLocaleMessages} from "@/i18n";
const i18nn = new VueI18n({
  locale: process.env.VUE_APP_I18N_LOCALE,
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE,
  messages: loadLocaleMessages(),
})
export default {
  components: {},
  i18n: i18nn,
  props: {
    data: Object,
    distributor: Object,
    me: Object,
  },
  mounted() {
    i18nn.locale = this.currencyType === 'USD' ? 'en' : 'vi'
  },
  data() {
    return {
      timePrint: {
        year: new Date().getFullYear(),
        month:
          new Date().getMonth() >= 10
            ? new Date().getMonth() + 1
            : `0${new Date().getMonth() + 1}`,
        day:
          new Date().getDate() >= 10
            ? new Date().getDate()
            : `0${new Date().getDate()}`,
        hour: new Date().getHours(),
        min: new Date().getMinutes(),
        sec: new Date().getSeconds(),
      },
    };
  },
  mixins: [UtilsMixin],
};
</script>

<template>
  <div class="page">
    <div class="d-flex justify-content-between">
      <div>
        <p class="text-uppercase mb-2 font-size-16">
          {{ distributor.distributor_name }}
        </p>
        <p class="text-uppercase mb-2 font-size-16">
          {{$t('print.address_x',{value: distributor.distributor_address})}}
        </p>
        <p class="text-uppercase mb-0 font-size-16">
          {{$t('print.tel_x', {value: distributor.distributor_phone})}}
        </p>
      </div>
    </div>
    <h2 class="text-uppercase text-center pt-3">{{$t('print.receipt')}}</h2>
    <p class="text-center">{{$t('print.number_x', {value: data.gr_id})}}</p>
    <div class="print-content" v-if="data.gr_type === 'NMH'">
      <p class="font-size-16">{{$t('print.warehouse')}}: {{ data.warehouse.warehouse_name }}</p>
      <p v-if="data.trademark" class="font-size-16">
        {{$t('print.brand')}}: {{ data.trademark.trademark_name }}
      </p>
    </div>
    <div class="print-content" v-if="data.gr_type === 'NNB'">
      <p class="font-size-16">{{$t('print.warehouse_import')}}: {{ data.warehouse.warehouse_name }}</p>
      <p v-if="data.export_from_name" class="font-size-16">
        {{$t('print.warehouse_export')}}: {{ data.export_from_name }}
      </p>
      <p v-if="data.shipper_name" class="font-size-16">
        {{$t('print.deliver')}}: {{ data.shipper_name }} - {{ data.shipper_phone }}
      </p>
    </div>
    <div class="print-content" v-if="data.gr_type === 'NTB'">
      <p class="font-size-16">{{$t('print.warehouse_import')}}: {{ data.warehouse.warehouse_name }}</p>
      <p v-if="data.export_from_name" class="font-size-16">
        Salesman: {{ data.export_from_name }}
      </p>
      <p v-if="data.trademark" class="font-size-16">
        {{$t('print.brand')}}: {{ data.trademark.trademark_name }}
      </p>
    </div>
    <!-- Nhập trả lại -->
    <div class="print-content" v-if="data.gr_type === 'NTL'">
      <p class="font-size-16">{{$t('print.warehouse_import')}}: {{ data.warehouse.warehouse_name }}</p>
      <p v-if="data.export_from_name" class="font-size-16">
        {{$t('print.return_object')}}:
        <span v-if="data.gr_type_extra === 'SALESMAN'">{{$t('print.from_salesman')}}</span>
        <span v-if="data.gr_type_extra === 'CUSTOMER'">{{$t('print.from_customer')}}</span>
        <span v-if="data.gr_type_extra === 'AGENCY'">{{$t('print.from_agency')}}</span>
        <span v-if="data.gr_type_extra === 'SHIPPER'">{{$t('print.from_shipper')}}</span>
      </p>
      <p class="pl-3">- {{$t('print.customer')}}: {{ data.export_from_name }}</p>
      <p class="pl-3">
        - {{$t('print.shipper')}}:
        {{
          data.gr_type_extra === "SHIPPER"
            ? data.shipper_name
            : data.export_from_name
        }}
      </p>
      <p v-if="data.reference_info.length > 0" class="font-size-16">
        {{$t('reference')}}: {{ data.reference_info[0].document_id }}
      </p>
    </div>
    <div
      class="print-content"
      v-if="data.gr_type === 'NDC' || data.gr_type === 'NKK'"
    >
      <p class="font-size-16">{{$t('print.warehouse')}}: {{ data.warehouse.warehouse_name }}</p>
    </div>
    <p class="font-size-16">{{$t('print.time')}}: {{ formatDateUnix(data.gr_time) }}</p>
    <p class="font-size-16">{{$t('print.note')}}: {{ data.note }}</p>
    <table class="table table-bordered font-size-16 border-black">
      <tr>
        <th>{{$t('print.code')}}</th>
        <th>{{$t('print.item_name')}}</th>
        <th>{{$t('print.unit')}}</th>
        <th>{{$t('print.quantity')}}</th>
        <th>{{$t('print.price')}}</th>
        <th>{{$t('print.discount')}}</th>
        <th>{{$t('print.vat')}}%</th>
        <th>{{$t('print.final_amount')}}</th>
      </tr>
      <tr v-for="(item, key) of data.details" :key="key">
        <td>{{ item.sku }}</td>
        <td>{{ item.item_name }}</td>
        <td>{{ item.unit_name }}</td>
        <td>{{ item.receipt_qty }}</td>
        <td>{{ formatPrice(item.price) }}</td>
        <td>{{ formatPrice(item.discount_amount) }}</td>
        <td>{{ item.vat }}</td>
        <td>{{ formatPrice(item.amount) }}</td>
      </tr>
      <tr>
        <td class="font-weight-bold" colspan="7">{{$t('print.vat')}}</td>
        <td class="font-weight-bold">{{
            formatPrice(data.amount_vat)
          }} đ</td>
      </tr>
      <tr>
        <td class="font-weight-bold" colspan="7">{{$t('print.amount')}}</td>
        <td class="font-weight-bold">{{ formatPrice(data.total_amount) }}</td>
      </tr>
      <tfoot class="footer-repeat no-border">
        <!-- add repeated tfoot for extra space -->
        <tr class="no-border">
          <td class="no-border">&nbsp;</td>
        </tr>
      </tfoot>
    </table>
    <!-- Chữ ký cho nhập trả lại -->
    <div
      v-if="data.gr_type === 'NTL'"
      class="print-footer d-flex justify-content-around font-size-16 pt-3"
    >
      <div>
        <p class="invisible">-</p>
        <p class="font-weight-medium text-center mb-0">{{$t('print.stockier')}}</p>
        <p class="font-italic text-center">({{$t('print.sign_full_name')}})</p>
      </div>
      <div>
        <p class="invisible">-</p>
        <p class="font-weight-medium text-center mb-0">{{$t('print.shipper')}}</p>
        <p class="font-italic text-center">({{$t('print.sign_full_name')}})</p>
      </div>
      <div>
        <p>
          Ngày {{ timePrint.day }} tháng {{ timePrint.month }} năm
          {{ timePrint.year }}
        </p>
        <p class="font-weight-medium text-center mb-0">{{$t('print.accountant')}}</p>
        <p class="font-italic text-center">({{$t('print.sign_full_name')}})</p>
      </div>
    </div>
    <div
      v-else-if="data.gr_type === 'NKK'"
      class="print-footer d-flex justify-content-around font-size-16 pt-3"
    >
      <div>
        <p class="invisible">-</p>
        <p class="font-weight-medium text-center mb-0">{{$t('print.stockier')}}</p>
        <p class="font-italic text-center">({{$t('print.sign_full_name')}})</p>
      </div>
      <div>
        <p class="invisible">-</p>
        <p class="font-weight-medium text-center mb-0">{{$t('importer')}}</p>
        <p class="font-italic text-center">({{$t('print.sign_full_name')}})</p>
      </div>
      <div>
        <p>
          Ngày {{ timePrint.day }} tháng {{ timePrint.month }} năm
          {{ timePrint.year }}
        </p>
        <p class="font-weight-medium text-center mb-0">{{$t('print.accountant')}}</p>
        <p class="font-italic text-center">({{$t('print.sign_full_name')}})</p>
      </div>
    </div>
    <div
      v-else
      class="print-footer d-flex justify-content-around font-size-16 pt-3"
    >
      <div>
        <p class="invisible">-</p>
        <p class="font-weight-medium text-center mb-0">{{$t('print.accountant')}}</p>
        <p class="font-italic text-center">({{$t('print.sign_full_name')}})</p>
      </div>
      <div>
        <p class="invisible">-</p>
        <p class="font-weight-medium text-center mb-0">
          {{ data.gr_type === "NTL" ? $t('print.shipper') : $t('print.accountant') }}
        </p>
        <p class="font-italic text-center">({{$t('print.sign_full_name')}})</p>
      </div>
      <div>
        <p>
          Ngày {{ timePrint.day }} tháng {{ timePrint.month }} năm
          {{ timePrint.year }}
        </p>
        <p class="font-weight-medium text-center mb-0">{{$t('print.voter_order')}}</p>
        <p class="font-italic text-center">({{$t('print.sign_full_name')}})</p>
      </div>
    </div>
  </div>
</template>
